import type { OwnedAccount } from '@hotjar/account';
import { goToCreateNewTicket } from '@hotjar/webapp/help/actions';
import type { Site } from '@hotjar/site';
import { closedModal, formSubmit, loadedModal } from '@hotjar/webapp/tracking/common';
import { extractAccountGroupingProps } from '@hotjar/webapp/tracking/utils';
import { PaymentData } from '@hotjar/webapp/billing/plan';
import { noop } from '@hotjar/webapp/lib/function';
import { openYearlyUpsellModal } from './YearlyUpsellModal';
import { checkout } from '../utils/checkout';
import { BILLING_CYCLE } from '../types';
import { openCompanyDetailsModal } from '../CompanyDetails';

const yearlyUpsellModalName = 'Switch to annual billing';

// eslint-disable-next-line func-params-args/func-params
export async function startYearlyUpsell(
  ownedAccount: OwnedAccount,
  currentSite: Site,
  uiPosition: string,
  currentLang: string,
): Promise<void> {
  if (!ownedAccount.hasPaymentDetails) {
    await openCompanyDetailsModal();
  }

  loadedModal(yearlyUpsellModalName, extractAccountGroupingProps(ownedAccount), {
    ui_position: uiPosition,
  });

  openYearlyUpsellModal({
    account: ownedAccount,
    goToCreateNewTicket: () => goToCreateNewTicket(currentSite, currentLang),
  }).then(
    ({ paymentMethod }): void => {
      formSubmit({
        name: yearlyUpsellModalName,
        submitSuccess: true,
        groupData: extractAccountGroupingProps(ownedAccount),
        data: {},
      });

      checkout({
        account: ownedAccount,
        paymentData: new PaymentData(),
        paymentMethod,
        billingCycle: BILLING_CYCLE.yearly,
      })
        .then(() => {
          window.location.reload();
        })
        .catch(noop);
    },
    () => {
      closedModal(yearlyUpsellModalName, extractAccountGroupingProps(ownedAccount), {});
    },
  );
}
